import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessageTemplatesService {

  api: string = environment.apiEndPoint;

  constructor(private http: HttpClient) { }

  templatesList(PageIdex: any) {
    return this.http.get(this.api+'/Template/GetAll?'+'PageIdex='+ PageIdex);
  }

  saveTemplate(data: any) {
    return this.http.post(this.api+'/Template',data);
  }

  updateTemplate(data: any) {
    return this.http.put(this.api+'/Template',data);
  }

  getTemplate(id: any) {
    return this.http.get(this.api+'/Template?TemplateId='+ id);
  }
  
  deleteTemplate(id: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        templateId: id
      },
    };
    return this.http.delete(this.api+'/Template', options);
  }
}
